import React from "react";

const Hamburger = ({ color, height, width }) => (
  <svg width={width} height={height} viewBox="0 0 22 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0 1.5C0 0.670312 0.702232 0 1.57143 0H20.4286C21.2978 0 22 0.670312 22 1.5C22 2.32969 21.2978 3 20.4286 3H1.57143C0.702232 3 0 2.32969 0 1.5ZM0 9C0 8.17031 0.702232 7.5 1.57143 7.5H20.4286C21.2978 7.5 22 8.17031 22 9C22 9.82969 21.2978 10.5 20.4286 10.5H1.57143C0.702232 10.5 0 9.82969 0 9ZM22 16.5C22 17.3297 21.2978 18 20.4286 18H1.57143C0.702232 18 0 17.3297 0 16.5C0 15.6703 0.702232 15 1.57143 15H20.4286C21.2978 15 22 15.6703 22 16.5Z"
      fill={color}
    />
  </svg>
);

Hamburger.defaultProps = {
  width: 28,
  height: 28,
  color: "black"
};

export default Hamburger;
